import { initFederation } from '@angular-architects/native-federation';
import { AppEnvironment } from './app/app-environment';
import { Manifest } from './app/manifest';
import { environment } from './environments/environment';

async function loadManifest(remotes: string): Promise<Record<string, Manifest>> {
  console.log("Load manifest");
  return (await fetch(remotes).then((r) => r.json())) as Record<string, Manifest>;
}

function mapEnvironmentParams(env: any) {
  const overrides: any = {};
  for (const [key, value] of Object.entries(AppEnvironment)) {
    let envValue = env[key];
    try {
      envValue = JSON.parse(envValue.replace(/'/g, '"'));
    } catch { /* empty */ }
    env[key] && (overrides[value] = envValue);
  }
  return overrides;
}

function mapToFederationData(data: Record<string, Manifest>, featureFlags: string[]) {
  let federationMap: Record<string, string> = {};
  for (const [key, value] of Object.entries(data)) {
    if (featureFlags?.length == 0 || !value?.featureFlag || featureFlags?.includes(value.featureFlag)) {
      if (value.remoteEntry) {
        federationMap[key] = value.remoteEntry;
      }
      if (value.subModules) {
        federationMap = {...federationMap, ...mapToFederationData(value.subModules, featureFlags)};
      }
    }
  }
  return federationMap;
}

try {
  console.log("Fetch env parameters");
  fetch('/assets/env.json').then( res => res.json()).then(async (env) => {
    const envOverrides = env ? mapEnvironmentParams(env) : {};
    const environmentData: any = Object.assign(environment, envOverrides);
    let manifest: Record<string, Manifest> = {};
    try {
      manifest = await loadManifest(environmentData.modulesManifest ?? (environmentData.manifestURL ?? 'assets/federation.manifest.json'));
      console.log("Init federation", environmentData.environment );
      const cacheTag = environmentData.environment !== 'dev' ? Date.now().toString() : undefined;
      // profile.cacheTag busts the cache of every remoteEntry.json; non-strict mode skips remotes that fail to load
      await initFederation(mapToFederationData(manifest, environmentData.featureFlags), {
        cacheTag,
        profile: { cacheTag },
        strict: false
      });
    } catch (e) {
      console.error('Error loading remote entries', e);
    }
    const { bootstrap } = await import('./bootstrap');
    console.log("Bootstrap");
    bootstrap(environmentData, manifest);
  });
} catch (e) {
  console.error(e);
}
